"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _resource = require("@/api/admin/resource/resource");
var _message = require("_l/message");
var _vuex = require("vuex");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _IconSelect = _interopRequireDefault(require("@/components/IconSelect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'resource-manage',
  components: {
    IconSelect: _IconSelect.default,
    TablePage: _tablePage.default,
    VueTreeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      tableUrl: '/system/resource/getResourceTreeList',
      columns: [{
        label: '标题',
        prop: 'title',
        align: 'left',
        width: '400'
      }, {
        label: '类型',
        slot: 'type'
      }, {
        label: '权限标识',
        prop: 'permission'
      }, {
        label: '状态',
        slot: 'resStatus'
      }, {
        label: '排序',
        prop: 'resSort'
      }, {
        label: '创建时间',
        prop: 'createDate'
      }, {
        label: '操作',
        slot: 'action'
      }],
      dialogShow: false,
      dialogTitle: '添加模块',
      form: {},
      rules: {},
      statusOptionList: [],
      httpMethodOptionList: [],
      resourceTypeOptionList: [],
      expansion: false,
      menuList: [],
      normalizer: function normalizer(node) {
        return {
          id: node.id,
          label: node.title,
          children: node.children
        };
      }
    };
  },
  watch: {
    'form.type': function formType(newVal, oldVal) {
      switch (newVal) {
        case '1':
        case '2':
          this.$set(this.form, 'menuExtFlag', '2');
          this.$set(this.form, 'menuCacheFlag', '2');
          this.$set(this.form, 'menuHiddenFlag', '1');
          break;
        case '3':
          this.$set(this.form, 'menuExtFlag', null);
          this.$set(this.form, 'menuCacheFlag', null);
          this.$set(this.form, 'menuHiddenFlag', null);
          this.$set(this.form, 'routePath', null);
          this.$set(this.form, 'componentName', null);
          this.$set(this.form, 'componentPath', null);
          this.$set(this.form, 'menuIcon', null);
          break;
      }
    },
    'form.menuExtFlag': function formMenuExtFlag(newVal, oldVal) {
      if (newVal === '1') {
        this.$set(this.form, 'permission', null);
        this.$set(this.form, 'resPath', null);
        this.$set(this.form, 'httpMethod', null);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    change: function change(e) {
      this.$forceUpdate();
    },
    changeExtFlag: function changeExtFlag(val) {
      this.$set(this.form, 'menuExtFlag', val);
    },
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    addResource: function addResource() {
      this.dialogTitle = '添加模块';
      this.form = {
        parentId: 0,
        parentIds: 0,
        // 目录
        type: '1',
        // 状态
        resStatus: '0',
        // 排序
        resSort: '500',
        // 菜单和目录是可见的
        menuHiddenFlag: '1',
        // 不是 外链菜单
        menuExtFlag: '2',
        // 不是 菜单缓存
        menuCacheFlag: '2'
      };
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      this.form = _objectSpread({}, row);
      this.dialogTitle = '修改模块';
      this.dialogShow = true;
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _resource.deleteResourceById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this2.dialogTitle === '添加模块') {
            (0, _resource.addResource)(_this2.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this2.cancelDialogAndRefresh();
            });
          } else {
            (0, _resource.updateResource)(_this2.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this2.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    },
    toggleRowExpansion: function toggleRowExpansion(isExpansion) {
      this.expansion = !this.expansion;
      this.toggleRowExpansion_forAll(this.$refs.tablePage.$refs.tableMain.data, isExpansion);
    },
    toggleRowExpansion_forAll: function toggleRowExpansion_forAll(data, isExpansion) {
      var _this3 = this;
      data.forEach(function (item) {
        _this3.$refs.tablePage.$refs.tableMain.toggleRowExpansion(item, isExpansion);
        if (item.children !== undefined && item.children !== null) {
          _this3.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      });
    },
    // 选中图标
    iconSelected: function iconSelected(name) {
      this.form.menuIcon = name;
      this.$forceUpdate();
    },
    treeSelect: function treeSelect(node, instanceId) {
      if (node.parentIds !== 0) {
        this.form.parentIds = node.parentIds + ',' + node.id;
      } else {
        this.form.parentIds = node.id;
      }
    }
  }),
  mounted: function mounted() {
    var _this4 = this;
    this.getDictListByType('res_status').then(function (res) {
      _this4.statusOptionList = res;
    });
    this.getDictListByType('resource_type').then(function (res) {
      _this4.resourceTypeOptionList = res;
    });
    this.getDictListByType('http_method').then(function (res) {
      _this4.httpMethodOptionList = res;
    });
    (0, _resource.getMenuList)().then(function (res) {
      _this4.menuList.unshift({
        id: 0,
        title: '顶级类目',
        parentIds: 0,
        children: res.data
      });
    });
  }
};